"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productsResponse = exports.password = exports.ocapiOrderResponse = exports.ocapiFaultResponse = exports.ocapiBasketWithPaymentInstrumentAndBillingAddress = exports.ocapiBasketWithItem = exports.ocapiBasketResponse = exports.mockedRegisteredCustomerWithTwoAddresses = exports.mockedRegisteredCustomer = exports.mockedGuestCustomer = exports.mockedEmptyCustomerProductList = exports.mockedCustomerProductListsDetails = exports.mockedCustomerProductLists = exports.mockShippingMethods = exports.mockProductSearch = exports.mockPaymentMethods = exports.mockOrderProducts = exports.mockOrderHistory = exports.mockCategory = exports.mockCategories = exports.expiredAuthToken = exports.exampleTokenReponseForRefresh = exports.exampleTokenReponse = exports.exampleRedirectUrl = exports.examplePKCEVerifier = exports.email = void 0;
/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const examplePKCEVerifier = exports.examplePKCEVerifier = 'sWSk9W.BiH7Ssv-_mwe6EsYk3OeH9OZ3qE9210l9L9mYDtZL9zETSHzOJPj4Oymp5VGkCn_1r7IOW7-IpGDVzPfTzUdY25TQuBkM1BKTG_41iOB3AI9JOd3f.~Q.DvvY';
const exampleTokenReponse = exports.exampleTokenReponse = {
  access_token: 'eyJ2ZXIiOiIxLjAiLCJraWQiOiI4ZWM1YWZjOC03MjczLTQxYmYtOWU2MS00MWRkMTAyODU2ZmMiLCJ0eXAiOiJqd3QiLCJjbHYiOiJKMi4xLjAiLCJhbGciOiJFUzI1NiJ9.eyJhdXQiOiJHVUlEIiwic2NwIjoic2ZjYy5zaG9wcGVyLWNhdGVnb3JpZXMgc2ZjYy5zaG9wcGVyLWN1c3RvbWVycy5yZWdpc3RlciBzZmNjLnNob3BwZXItY3VzdG9tZXJzLmxvZ2luIHNmY2Muc2hvcHBlci1teWFjY291bnQgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5ydyBzZmNjLnNob3BwZXItbXlhY2NvdW50LmFkZHJlc3Nlcy5ydyBzZmNjLnNob3BwZXItbXlhY2NvdW50LmFkZHJlc3NlcyBzZmNjLnNob3BwZXItbXlhY2NvdW50LmJhc2tldHMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5vcmRlcnMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wYXltZW50aW5zdHJ1bWVudHMucncgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wYXltZW50aW5zdHJ1bWVudHMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wcm9kdWN0bGlzdHMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wcm9kdWN0bGlzdHMucncgc2ZjYy5zaG9wcGVyLXByb2R1Y3RsaXN0cyBzZmNjLnNob3BwZXItcHJvbW90aW9ucyBzZmNjLnNob3BwZXItZ2lmdC1jZXJ0aWZpY2F0ZXMgc2ZjYy5zaG9wcGVyLXByb2R1Y3Qtc2VhcmNoIHNmY2Muc2hvcHBlci1iYXNrZXRzLW9yZGVycy5ydyBzZmNjLnNob3BwZXItYmFza2V0cy1vcmRlcnMgc2ZjYy5zaG9wcGVyLXByb2R1Y3RzIiwic3ViIjoiY2Mtc2xhczo6enpyZl8wMDE6OnNjaWQ6YzljNDViZmQtMGVkMy00YWEyLTk5NzEtNDBmODg5NjJiODM2Ojp1c2lkOmY1MWZkNDkxLWViYTEtNDU4Mi04MWY5LTRhMDE0YTQ3MmEyMCIsImN0eCI6InNsYXMiLCJpc3MiOiJzbGFzL3Byb2QvenpyZl8wMDEiLCJpc3QiOjEsImF1ZCI6ImNvbW1lcmNlY2xvdWQvcHJvZC96enJmXzAwMSIsIm5iZiI6MTYxNTU2NTY2NCwic3R5IjoiVXNlciIsImlzYiI6InVpZG86ZWNvbTo6dXBuOnJlZnRlc3RANjRsYWJzLmNvbTo6dWlkbjpEYXJlayBSb3NzbWFuIiwiZXhwIjoxNjE1NTY3NDk0LCJpYXQiOjE2MTU1NjU2OTQsImp0aSI6IkMyQzQ4NTYyMDE4NjAtMTg5MDY3ODkwMzY1MzAyMTAyODM3OTUyOCJ9.a6hXCRArmoqZOnoiUW9Ed9id2hY_Q2ZsKL2MMpJuiv65aIlFmi1S5gAXHLNFnL-OSd8oRyOIb-W9YnsCb2ISzQ',
  id_token: 'eyJraWQiOiI3MTUxNmI0My1lNzBkLTQ5NDktYjhmNy00NTdkM2JmMjY2ZjMiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJjYy1zbGFzOjp6enJmXzAwMTo6c2NpZDpjOWM0NWJmZC0wZWQzLTRhYTItOTk3MS00MGY4ODk2MmI4MzY6OnVzaWQ6ZjUxZmQ0OTEtZWJhMS00NTgyLTgxZjktNGEwMTRhNDcyYTIwIiwiYXVkIjoiYzljNDViZmQtMGVkMy00YWEyLTk5NzEtNDBmODg5NjJiODM2IiwiaXNzIjoicHJkLnVzLnNob3BwZXIuY2Muc2FsZXNmb3JjZS5jb20iLCJuYW1lIjoiZWNvbSIsImV4cCI6MTYxNTU2NzQ5NCwiaWF0IjoxNjE1NTY1Njk0LCJlbWFpbCI6ImVjb20ifQ.KgaXzEH1pisXLigTvBB_U9Xw0aQeowJiawQzCewZlQDrh7P0iOthfVnTHBMwvntJow0uSh3_78HFBlhNWsqy2szCHjR7dLtjN0oqb9izDhOjyslR2bAvfM24cR-Uor40oNx1h2d7oELOmFsn0Dr8sgl6gQIQolGfdnCHSBLTDeD12vzgBAzjYO8nBZ8r8HOO6yqOCHpyD6aqzmzYpBLluyXU1Ul04qlCNKm9_Dn7HFlKWkZyujlyPQdLz_ql7QnuKGpW_dZzqBfeO5LJBvbybw2AW07bVBFTnn5LisMnMxNVoCiLnUAzxtZMthQY1OZLzhZwITmuSBstaHZF8mACBQ',
  refresh_token: 'bvMQkZbDnYYaheqDq3x6JhOlhUhHSUzh1f9geEadTQw',
  expires_in: 1800,
  token_type: 'BEARER',
  usid: 'f51fd491-eba1-4582-81f9-4a014a472a20',
  customer_id: 'customerid',
  enc_user_id: 'ce5f0dd2fc1fdb7f06e8e97011200943'
};
const exampleTokenReponseForRefresh = exports.exampleTokenReponseForRefresh = {
  access_token: 'eyJ2ZXIiOiIxLjAiLCJraWQiOiI4ZWM1YWZjOC03MjczLTQxYmYtOWU2MS00MWRkMTAyODU2ZmMiLCJ0eXAiOiJqd3QiLCJjbHYiOiJKMi4xLjAiLCJhbGciOiJFUzI1NiJ9.eyJhdXQiOiJHVUlEIiwic2NwIjoic2ZjYy5zaG9wcGVyLWNhdGVnb3JpZXMgc2ZjYy5zaG9wcGVyLWN1c3RvbWVycy5yZWdpc3RlciBzZmNjLnNob3BwZXItY3VzdG9tZXJzLmxvZ2luIHNmY2Muc2hvcHBlci1teWFjY291bnQgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5ydyBzZmNjLnNob3BwZXItbXlhY2NvdW50LmFkZHJlc3Nlcy5ydyBzZmNjLnNob3BwZXItbXlhY2NvdW50LmFkZHJlc3NlcyBzZmNjLnNob3BwZXItbXlhY2NvdW50LmJhc2tldHMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5vcmRlcnMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wYXltZW50aW5zdHJ1bWVudHMucncgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wYXltZW50aW5zdHJ1bWVudHMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wcm9kdWN0bGlzdHMgc2ZjYy5zaG9wcGVyLW15YWNjb3VudC5wcm9kdWN0bGlzdHMucncgc2ZjYy5zaG9wcGVyLXByb2R1Y3RsaXN0cyBzZmNjLnNob3BwZXItcHJvbW90aW9ucyBzZmNjLnNob3BwZXItZ2lmdC1jZXJ0aWZpY2F0ZXMgc2ZjYy5zaG9wcGVyLXByb2R1Y3Qtc2VhcmNoIHNmY2Muc2hvcHBlci1iYXNrZXRzLW9yZGVycy5ydyBzZmNjLnNob3BwZXItYmFza2V0cy1vcmRlcnMgc2ZjYy5zaG9wcGVyLXByb2R1Y3RzIiwic3ViIjoiY2Mtc2xhczo6enpyZl8wMDE6OnNjaWQ6YzljNDViZmQtMGVkMy00YWEyLTk5NzEtNDBmODg5NjJiODM2Ojp1c2lkOmY1MWZkNDkxLWViYTEtNDU4Mi04MWY5LTRhMDE0YTQ3MmEyMCIsImN0eCI6InNsYXMiLCJpc3MiOiJzbGFzL3Byb2QvenpyZl8wMDEiLCJpc3QiOjEsImF1ZCI6ImNvbW1lcmNlY2xvdWQvcHJvZC96enJmXzAwMSIsIm5iZiI6MTYxNTU2NTY2NCwic3R5IjoiVXNlciIsImlzYiI6InVpZG86ZWNvbTo6dXBuOnJlZnRlc3RANjRsYWJzLmNvbTo6dWlkbjpEYXJlayBSb3NzbWFuIiwiZXhwIjoxNjE1NTY3NDk0LCJpYXQiOjE2MTU1NjU2OTQsImp0aSI6IkMyQzQ4NTYyMDE4NjAtMTg5MDY3ODkwMzY1MzAyMTAyODM3OTUyOCJ9.a6hXCRArmoqZOnoiUW9Ed9id2hY_Q2ZsKL2MMpJuiv65aIlFmi1S5gAXHLNFnL-OSd8oRyOIb-W9YnsCb2IJGK',
  id_token: 'eyJraWQiOiI3MTUxNmI0My1lNzBkLTQ5NDktYjhmNy00NTdkM2JmMjY2ZjMiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJjYy1zbGFzOjp6enJmXzAwMTo6c2NpZDpjOWM0NWJmZC0wZWQzLTRhYTItOTk3MS00MGY4ODk2MmI4MzY6OnVzaWQ6ZjUxZmQ0OTEtZWJhMS00NTgyLTgxZjktNGEwMTRhNDcyYTIwIiwiYXVkIjoiYzljNDViZmQtMGVkMy00YWEyLTk5NzEtNDBmODg5NjJiODM2IiwiaXNzIjoicHJkLnVzLnNob3BwZXIuY2Muc2FsZXNmb3JjZS5jb20iLCJuYW1lIjoiZWNvbSIsImV4cCI6MTYxNTU2NzQ5NCwiaWF0IjoxNjE1NTY1Njk0LCJlbWFpbCI6ImVjb20ifQ.KgaXzEH1pisXLigTvBB_U9Xw0aQeowJiawQzCewZlQDrh7P0iOthfVnTHBMwvntJow0uSh3_78HFBlhNWsqy2szCHjR7dLtjN0oqb9izDhOjyslR2bAvfM24cR-Uor40oNx1h2d7oELOmFsn0Dr8sgl6gQIQolGfdnCHSBLTDeD12vzgBAzjYO8nBZ8r8HOO6yqOCHpyD6aqzmzYpBLluyXU1Ul04qlCNKm9_Dn7HFlKWkZyujlyPQdLz_ql7QnuKGpW_dZzqBfeO5LJBvbybw2AW07bVBFTnn5LisMnMxNVoCiLnUAzxtZMthQY1OZLzhZwITmuSBstaHZF8mACBQ',
  refresh_token: 'bvMQkZbDnYYaheqDq3x6JhOlhUhHSUzh1f9geEadTQw',
  expires_in: 1800,
  token_type: 'BEARER',
  usid: 'f51fd491-eba1-4582-81f9-4a014a472a20',
  customer_id: 'customerid',
  enc_user_id: 'ce5f0dd2fc1fdb7f06e8e97011200943'
};
const exampleRedirectUrl = exports.exampleRedirectUrl = 'http://localhost:3000/callback?usid=395ac523-27dc-439e-b3a5-4a7ff6376392&state=1615564861486&scope=openid%20offline_access&code=Th32jvj25gC87fo48RYn3zRbxVhsDCyDT4kIaBh7QFM ';
const email = exports.email = 'reftest@64labs.com';
const password = exports.password = '64Labs2020!';
const expiredAuthToken = exports.expiredAuthToken = 'Bearer eyJhbGciOiJFUzI1NiIsImtpZCI6IjE2MDc1MzkwMDUwNTciLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJjOWM0NWJmZC0wZWQzLTRhYTItOTk3MS00MGY4ODk2MmI4MzYiLCJleHAiOjE2MTIzNjY4NTcsImlhdCI6MTYxMjM2NTA1NywiaXNzIjoiY29tbWVyY2VjbG91ZC9wcm9kdWN0aW9uL3p6cmYtMDAxLTY0NDlhYTgzLTUwYzItNGE1Yy1iNGE2LWIyM2VjOWNkMGExOS0zIiwic2NvcGUiOlsiU0FMRVNGT1JDRV9DT01NRVJDRV9BUEk6enpyZl8wMDEiLCJzZmNjLnByb2R1Y3RzLnJ3Iiwic2ZjYy5zaG9wcGVyLWJhc2tldHMtb3JkZXJzLnJ3Iiwic2ZjYy5zaG9wcGVyLWNhdGVnb3JpZXMiLCJzZmNjLnNob3BwZXItY3VzdG9tZXJzLmxvZ2luIiwic2ZjYy5zaG9wcGVyLWN1c3RvbWVycy5yZWdpc3RlciIsInNmY2Muc2hvcHBlci1naWZ0LWNlcnRpZmljYXRlcyIsInNmY2Muc2hvcHBlci1teWFjY291bnQuYWRkcmVzc2VzLnJ3Iiwic2ZjYy5zaG9wcGVyLW15YWNjb3VudC5iYXNrZXRzIiwic2ZjYy5zaG9wcGVyLW15YWNjb3VudC5vcmRlcnMiLCJzZmNjLnNob3BwZXItbXlhY2NvdW50LnBheW1lbnRpbnN0cnVtZW50cy5ydyIsInNmY2Muc2hvcHBlci1teWFjY291bnQucHJvZHVjdGxpc3RzLnJ3Iiwic2ZjYy5zaG9wcGVyLW15YWNjb3VudC5ydyIsInNmY2Muc2hvcHBlci1wcm9kdWN0LXNlYXJjaCIsInNmY2Muc2hvcHBlci1wcm9tb3Rpb25zIiwic2ZjYy5zaG9wcGVyLnN0b3JlcyIsInNmY2Muc2hvcHBlci1wcm9kdWN0cyJdLCJzdWIiOiJ7XCJDdXN0b21lckluZm9cIjp7XCJjdXN0b21lcklkXCI6XCJhYlpYYk9IQ1NUUTJDUmNoVnpQUDNyUlVNaFwiLFwiZ3Vlc3RcIjp0cnVlLFwidmlzaXRJZFwiOlwiOTRmYjVhNGZhMWM5MzAzN2E4ZTg1YjJhMmJcIn19In0.JVbGySy4qk2DD1ZXTdTjNY_iWzlejX0L-rukF0qPIwyswYpRGr4MiTgh29c4AUSuhUdsqQtJoW1VcGvdYGU9Og';

// OCAPI MOCK DATA

const ocapiBasketResponse = exports.ocapiBasketResponse = {
  _v: '21.3',
  _resource_state: '860cde3040519cce439cd99e209f8a87c3ad0b7e2813edbf6f5501f763b73bd5',
  _type: 'basket',
  _flash: [],
  basket_id: 'bczFTaOjgEqUkaaadkvHwbgrP5',
  currency: 'USD',
  customer_info: {
    _type: 'customer_info',
    customer_id: 'adNJrbxJovaT5DPxUSfOywk6Et',
    email: ''
  },
  order_total: 0.0,
  product_sub_total: 0.0,
  product_total: 0.0,
  shipments: [{
    _type: 'shipment',
    id: 'me',
    shipment_id: 'bc5OTaOjgEqUoaaadkvHwbgrP5'
  }],
  shipping_items: [{
    shipment_id: 'me',
    item_id: 'bcwsbaOjgEqUsaaadkvHwbgrP5'
  }],
  shipping_total: 0.0,
  shipping_total_tax: 0.0,
  taxation: 'net',
  tax_total: 0.0
};
const ocapiBasketWithItem = exports.ocapiBasketWithItem = {
  _v: '21.3',
  _type: 'basket',
  _resource_state: 'd4ad608574e06ab2d6bfa5ffc861402d653740dd437b625eced2bc2f5adf801e',
  _flash: [{
    _type: 'flash',
    type: 'PaymentMethodRequired',
    message: 'No payment method ID was specified. Please provide a valid payment method ID.',
    path: '$.payment_instruments[0].payment_method_id'
  }, {
    _type: 'flash',
    type: 'BillingAddressRequired',
    message: 'No billing address was specified. Please provide a valid billing address.',
    path: '$.billing_address'
  }, {
    _type: 'flash',
    type: 'OrderTotalNotSet',
    message: 'Order total missing, calculation failed.',
    path: '$.order_total'
  }, {
    _type: 'flash',
    type: 'ShippingAddressRequired',
    message: 'No shipping address was specified. Please provide a valid shipping address.',
    path: '$.shipments[0].shipping_address',
    details: {
      shipmentId: 'me'
    }
  }, {
    _type: 'flash',
    type: 'ShippingMethodRequired',
    message: 'No shipping method ID was specified. Please provide a valid shipping method ID.',
    path: '$.shipments[0].shipping_method',
    details: {
      shipmentId: 'me'
    }
  }, {
    _type: 'flash',
    type: 'ShippingItemAdjustedPriceNotSet',
    message: "Price missing for shipping item ''b2a1772eb5c47263499cb6d86b''.",
    path: '$.shipping_items[0].adjusted_price'
  }],
  adjusted_merchandize_total_tax: 0.75,
  adjusted_shipping_total_tax: null,
  agent_basket: false,
  basket_id: '6d0ef818e2b431645b844e6ac2',
  channel_type: 'storefront',
  creation_date: '2021-04-08T19:54:00.772Z',
  currency: 'USD',
  customer_info: {
    _type: 'customer_info',
    customer_id: 'customerid',
    email: ''
  },
  last_modified: '2021-04-08T19:54:02.996Z',
  merchandize_total_tax: 0.75,
  notes: {
    _type: 'simple_link',
    link: 'https://zzrf-001.dx.commercecloud.salesforce.com/s/RefArch/dw/shop/v21_3/baskets/6d0ef818e2b431645b844e6ac2/notes'
  },
  order_total: null,
  product_items: [{
    _type: 'product_item',
    adjusted_tax: 0.75,
    base_price: 14.99,
    bonus_product_line_item: false,
    gift: false,
    item_id: '98183bf3bbf73fee56cf89d570',
    item_text: 'Long Sleeve Crew Neck',
    price: 14.99,
    price_after_item_discount: 14.99,
    price_after_order_discount: 14.99,
    product_id: '701642811398M',
    product_name: 'Long Sleeve Crew Neck',
    quantity: 2,
    shipment_id: 'me',
    tax: 0.75,
    tax_basis: 14.99,
    tax_class_id: 'standard',
    tax_rate: 0.05
  }],
  product_sub_total: 14.99,
  product_total: 14.99,
  shipments: [{
    _type: 'shipment',
    adjusted_merchandize_total_tax: 0.75,
    adjusted_shipping_total_tax: null,
    gift: false,
    merchandize_total_tax: 0.75,
    product_sub_total: 14.99,
    product_total: 14.99,
    shipment_id: 'me',
    shipment_total: null,
    shipping_status: 'not_shipped',
    shipping_total: null,
    shipping_total_tax: null,
    tax_total: null
  }],
  shipping_items: [{
    _type: 'shipping_item',
    adjusted_tax: null,
    base_price: null,
    item_id: 'b2a1772eb5c47263499cb6d86b',
    item_text: 'Shipping',
    price: null,
    price_after_item_discount: null,
    shipment_id: 'me',
    tax: null,
    tax_basis: null,
    tax_class_id: null,
    tax_rate: 0.05
  }],
  shipping_total: null,
  shipping_total_tax: null,
  taxation: 'net',
  tax_total: null
};
const ocapiBasketWithPaymentInstrumentAndBillingAddress = exports.ocapiBasketWithPaymentInstrumentAndBillingAddress = {
  _v: '21.3',
  _type: 'basket',
  _resource_state: 'd4ad608574e06ab2d6bfa5ffc861402d653740dd437b625eced2bc2f5adf801e',
  _flash: [{
    _type: 'flash',
    type: 'PaymentMethodRequired',
    message: 'No payment method ID was specified. Please provide a valid payment method ID.',
    path: '$.payment_instruments[0].payment_method_id'
  }, {
    _type: 'flash',
    type: 'BillingAddressRequired',
    message: 'No billing address was specified. Please provide a valid billing address.',
    path: '$.billing_address'
  }, {
    _type: 'flash',
    type: 'OrderTotalNotSet',
    message: 'Order total missing, calculation failed.',
    path: '$.order_total'
  }, {
    _type: 'flash',
    type: 'ShippingAddressRequired',
    message: 'No shipping address was specified. Please provide a valid shipping address.',
    path: '$.shipments[0].shipping_address',
    details: {
      shipmentId: 'me'
    }
  }, {
    _type: 'flash',
    type: 'ShippingMethodRequired',
    message: 'No shipping method ID was specified. Please provide a valid shipping method ID.',
    path: '$.shipments[0].shipping_method',
    details: {
      shipmentId: 'me'
    }
  }, {
    _type: 'flash',
    type: 'ShippingItemAdjustedPriceNotSet',
    message: "Price missing for shipping item ''b2a1772eb5c47263499cb6d86b''.",
    path: '$.shipping_items[0].adjusted_price'
  }],
  adjusted_merchandize_total_tax: 0.75,
  adjusted_shipping_total_tax: null,
  agent_basket: false,
  basket_id: '6d0ef818e2b431645b844e6ac2',
  billing_address: {
    _type: 'order_address',
    city: 'Boston',
    country_code: 'US',
    first_name: 'John',
    full_name: 'John Smith',
    last_name: 'Smith',
    c_strValue: 'cTest'
  },
  channel_type: 'storefront',
  creation_date: '2021-04-08T19:54:00.772Z',
  currency: 'USD',
  customer_info: {
    _type: 'customer_info',
    customer_id: 'customerid',
    email: ''
  },
  last_modified: '2021-04-08T19:54:02.996Z',
  merchandize_total_tax: 0.75,
  notes: {
    _type: 'simple_link',
    link: 'https://zzrf-001.dx.commercecloud.salesforce.com/s/RefArch/dw/shop/v21_3/baskets/6d0ef818e2b431645b844e6ac2/notes'
  },
  order_total: null,
  payment_instruments: [{
    _type: 'order_payment_instrument',
    amount: 1.0,
    payment_card: {
      _type: 'payment_card',
      card_type: 'Visa',
      credit_card_expired: false,
      expiration_month: 1,
      expiration_year: 2021,
      holder: 'John Doe',
      masked_number: '***********1111',
      number_last_digits: '1111'
    },
    payment_method_id: 'CREDIT_CARD',
    payment_instrument_id: 'ceDUYiWbN1IkkaaadkYHRkclwC',
    c_strValue: 'any custom value'
  }, {
    amount: 1.0,
    payment_bank_account: {
      drivers_license_last_digits: 'ense',
      drivers_license_masked: '**************ense',
      number_last_digits: 'mber',
      number_masked: '*************mber'
    },
    id: 'cdKCIiWbNVndQaaadhlSa35gtp',
    payment_card: {
      card_type: 'testVisa',
      credit_card_expired: false,
      expiration_month: 4,
      expiration_year: 21.2,
      holder: 'TestPerson',
      number_last_digits: 'mber',
      number_masked: '**********mber'
    },
    payment_method_id: 'OCAPI_Payment_Simple'
  }],
  product_items: [{
    _type: 'product_item',
    adjusted_tax: 0.75,
    base_price: 14.99,
    bonus_product_line_item: false,
    gift: false,
    item_id: '98183bf3bbf73fee56cf89d570',
    item_text: 'Long Sleeve Crew Neck',
    price: 14.99,
    price_after_item_discount: 14.99,
    price_after_order_discount: 14.99,
    product_id: '701642811398M',
    product_name: 'Long Sleeve Crew Neck',
    quantity: 1,
    shipment_id: 'me',
    tax: 0.75,
    tax_basis: 14.99,
    tax_class_id: 'standard',
    tax_rate: 0.05
  }],
  product_sub_total: 14.99,
  product_total: 14.99,
  shipments: [{
    _type: 'shipment',
    id: 'me',
    shipping_method: {
      _type: 'shipping_method',
      description: 'The default shipping method.',
      id: 'DefaultShippingMethod',
      name: 'Default Shipping Method',
      price: 5.55,
      c_somestring: 'ShippingMethod String Value'
    },
    shipment_id: 'cdKeciWbNL21saaadjZkbNt6xg'
  }, {
    _type: 'shipment',
    id: 'shipmentId123',
    shipping_address: {
      _type: 'order_address',
      city: 'Boston',
      country_code: 'US',
      first_name: 'John',
      full_name: 'John Smith',
      last_name: 'Smith',
      c_strValue: 'cTest'
    },
    shipment_id: 'cdOlsiWbNLWhkaaadjbQdNt6xg'
  }],
  shipping_items: [{
    _type: 'shipping_item',
    adjusted_tax: null,
    base_price: null,
    item_id: 'b2a1772eb5c47263499cb6d86b',
    item_text: 'Shipping',
    price: null,
    price_after_item_discount: null,
    shipment_id: 'me',
    tax: null,
    tax_basis: null,
    tax_class_id: null,
    tax_rate: 0.05
  }],
  shipping_total: null,
  shipping_total_tax: null,
  taxation: 'net',
  tax_total: null
};
const mockShippingMethods = exports.mockShippingMethods = {
  _v: '21.3',
  _type: 'shipping_method_result',
  applicable_shipping_methods: [{
    _type: 'shipping_method',
    _resource_state: '860cde3040519cce439cd99e209f8a87c3ad0b7e2813edbf6f5501f763b73bd5',
    description: 'The default shipping method.',
    id: 'DefaultShippingMethod',
    name: 'Default Shipping Method',
    price: 5.55,
    shipping_promotions: [{
      callout_msg: 'Free Shipping Amount Above 150',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/s/RefArch/dw/shop/v21_3/promotions/3184d71eea54c9d27e88dc41ca',
      promotion_id: 'FreeShippingAmountAbove150',
      promotion_name: 'Free Shipping Amount Above 150'
    }]
  }, {
    _type: 'shipping_method',
    _resource_state: '847f9c3c5867f641470b3046aeec31f07757991b792d722e10079926f7a289fb',
    description: 'The base shipping method.',
    id: 'BaseShippingMethod',
    name: 'Base Shipping Method',
    price: 0.99
  }, {
    _type: 'shipping_method',
    _resource_state: 'c3c5867f641470b3046aeec31f07757991b792d722e10079926f7a289fb',
    description: 'A shipping method that contains product level shipping costs.',
    id: 'ProductLevelShippingCostsShippingMethod',
    name: 'Product Level Shipping Costs Shipping Method',
    price: 0.1
  }],
  default_shipping_method_id: 'DefaultShippingMethod'
};
const ocapiOrderResponse = exports.ocapiOrderResponse = {
  _v: '21.3',
  _type: 'order',
  _resource_state: '860cde3040519cce439cd99e209f8a87c3ad0b7e2813edbf6f5501f763b73bd5',
  adjusted_merchandize_total_tax: 0.05,
  adjusted_shipping_total_tax: 0.0,
  billing_address: {
    city: 'Boston',
    country_code: 'US',
    first_name: 'Jeff',
    full_name: 'Jeff Lebowski',
    last_name: 'Lebowski',
    c_strValue: 'cTest'
  },
  creation_date: '2014-11-06T13:36Z',
  currency: 'USD',
  customer_info: {
    customer_id: 'customerid',
    customer_no: 'jlebowski',
    email: 'jeff@lebowski.com'
  },
  merchandize_total_tax: 5.0,
  order_no: '00000101',
  order_token: 'XizrH5hY1vB-Mxno-zfoCqTkegl3y7_OrRPGNZFlYG8',
  order_total: 1.06,
  payment_instruments: [{
    amount: 1.0,
    payment_bank_account: {
      drivers_license_last_digits: 'ense',
      drivers_license_masked: '**************ense',
      number_last_digits: 'mber',
      number_masked: '*************mber'
    },
    id: 'cdKCIiWbNVndQaaadhlSa35gtp',
    payment_card: {
      card_type: 'testVisa',
      credit_card_expired: false,
      expiration_month: 4,
      expiration_year: 21.2,
      holder: 'TestPerson',
      number_last_digits: 'mber',
      number_masked: '**********mber'
    },
    payment_method_id: 'OCAPI_Payment_Simple'
  }],
  product_items: [{
    adjusted_tax: 5.0,
    base_price: 16.49,
    bonus_product_line_item: false,
    item_text: 'Simple Product',
    price: 16.49,
    price_after_item_discount: 16.49,
    price_after_order_discount: 1.0,
    product_id: 'SimpleProduct',
    product_name: 'Simple Product',
    quantity: 1.0,
    tax: 5.0,
    tax_basis: 16.49,
    tax_class_id: null,
    tax_rate: 0.05,
    item_id: 'cdHBEiWbNV9ZcaaadhrCk35gtp',
    c_strValue: 'Test'
  }],
  product_sub_total: 16.49,
  product_total: 1.0,
  shipments: [{
    id: 'me',
    shipping_address: {
      city: 'Boston',
      country_code: 'US',
      first_name: 'Jeff',
      full_name: 'Jeff Lebowski',
      last_name: 'Lebowski',
      c_strValue: 'cTest'
    },
    shipping_method: {
      description: 'The base shipping method.',
      id: 'BaseShippingMethod',
      name: 'Base Shipping Method',
      price: 0.01,
      c_somestring: 'ShippingMethod String Value'
    }
  }],
  shipping_items: [{
    adjusted_tax: 0.0,
    base_price: 0.01,
    item_text: 'Shipping',
    price: 0.01,
    price_after_item_discount: 0.01,
    shipment_id: 'me',
    tax: 0.0,
    tax_basis: 0.01,
    tax_class_id: 'DefaultTaxClass',
    tax_rate: 0.05,
    item_id: 'devgoiWbNVc92aaadhrSk35gtp'
  }],
  shipping_total: 0.01,
  shipping_total_tax: 0.0,
  status: 'created',
  tax_total: 0.05,
  c_strValue: 'before submit basket',
  c_textValue: 'after submit basket'
};
const ocapiFaultResponse = exports.ocapiFaultResponse = {
  _v: '21.3',
  fault: {
    arguments: {
      basketIds: '2fa6195f3722bea373afc9953f'
    },
    type: 'CustomerBasketsQuotaExceededException',
    message: 'The maximum number of baskets per customer was exceeded. Please reuse or delete one of the existing baskets (2fa6195f3722bea373afc9953f).'
  }
};
const mockPaymentMethods = exports.mockPaymentMethods = {
  _v: '21.3',
  _type: 'payment_method_result',
  applicable_payment_methods: [{
    _type: 'payment_method',
    cards: [{
      _type: 'payment_card_spec',
      card_type: 'Visa',
      checksum_verification_enabled: true,
      name: 'Visa',
      number_lengths: ['13', '16'],
      number_prefixes: ['4'],
      security_code_length: 3
    }, {
      _type: 'payment_card_spec',
      card_type: 'Amex',
      checksum_verification_enabled: true,
      name: 'American Express',
      number_lengths: ['15'],
      number_prefixes: ['34', '37'],
      security_code_length: 4
    }, {
      _type: 'payment_card_spec',
      card_type: 'Master Card',
      checksum_verification_enabled: true,
      name: 'MasterCard',
      number_lengths: ['16'],
      number_prefixes: ['51-55'],
      security_code_length: 3
    }, {
      _type: 'payment_card_spec',
      card_type: 'Discover',
      checksum_verification_enabled: true,
      name: 'Discover',
      number_lengths: ['16'],
      number_prefixes: ['6011', '622126-622925', '644-649', '65'],
      security_code_length: 3
    }],
    id: 'CREDIT_CARD',
    name: 'Credit Card',
    payment_processor_id: 'BASIC_CREDIT'
  }]
};
const mockedRegisteredCustomerWithTwoAddresses = exports.mockedRegisteredCustomerWithTwoAddresses = {
  addresses: [{
    address1: '123 Main St',
    addressId: 'savedaddress1',
    city: 'Tampa',
    countryCode: 'US',
    creationDate: '2021-04-07T12:08:03.000Z',
    firstName: 'Test',
    fullName: 'Test McTester',
    lastModified: '2021-04-07T12:08:03.000Z',
    lastName: 'McTester',
    phone: '(727) 555-1234',
    postalCode: '33712',
    preferred: true,
    stateCode: 'FL'
  }, {
    address1: '123 Main St',
    addressId: 'savedaddress2',
    city: 'Tampa',
    countryCode: 'US',
    creationDate: '2021-04-07T12:08:03.000Z',
    firstName: 'Test2',
    fullName: 'Test2 McTester',
    lastModified: '2021-04-07T12:08:03.000Z',
    lastName: 'McTester',
    phone: '(727) 555-1234',
    postalCode: '33712',
    preferred: true,
    stateCode: 'FL'
  }],
  authType: 'registered',
  creationDate: '2021-03-31T13:32:42.000Z',
  customerId: 'customerid',
  customerNo: '00149004',
  email: 'customer@test.com',
  enabled: true,
  lastLoginTime: '2021-04-14T13:38:29.778Z',
  lastModified: '2021-04-14T13:38:29.778Z',
  firstName: 'Testing',
  lastName: 'Tester',
  phoneHome: '(727) 555-1234',
  lastVisitTime: '2021-04-14T13:38:29.778Z',
  login: 'customer@test.com',
  paymentInstruments: [{
    creationDate: '2021-04-01T14:34:56.000Z',
    lastModified: '2021-04-01T14:34:56.000Z',
    paymentBankAccount: {},
    paymentCard: {
      cardType: 'Master Card',
      creditCardExpired: false,
      expirationMonth: 1,
      expirationYear: 2030,
      holder: 'Test McTester',
      maskedNumber: '************5454',
      numberLastDigits: '5454',
      validFromMonth: 1,
      validFromYear: 2020
    },
    paymentInstrumentId: 'testcard1',
    paymentMethodId: 'CREDIT_CARD'
  }],
  previousLoginTime: '2021-04-14T13:38:29.778Z',
  previousVisitTime: '2021-04-14T13:38:29.778Z'
};
const mockedRegisteredCustomer = exports.mockedRegisteredCustomer = {
  addresses: [{
    address1: '123 Main St',
    addressId: 'savedaddress1',
    city: 'Tampa',
    countryCode: 'US',
    creationDate: '2021-04-07T12:08:03.000Z',
    firstName: 'Test',
    fullName: 'Test McTester',
    lastModified: '2021-04-07T12:08:03.000Z',
    lastName: 'McTester',
    phone: '(727) 555-1234',
    postalCode: '33712',
    preferred: true,
    stateCode: 'FL'
  }],
  authType: 'registered',
  creationDate: '2021-03-31T13:32:42.000Z',
  customerId: 'customerid',
  customerNo: '00149004',
  email: 'customer@test.com',
  enabled: true,
  lastLoginTime: '2021-04-14T13:38:29.778Z',
  lastModified: '2021-04-14T13:38:29.778Z',
  firstName: 'Testing',
  lastName: 'Tester',
  phoneHome: '(727) 555-1234',
  lastVisitTime: '2021-04-14T13:38:29.778Z',
  login: 'customer@test.com',
  paymentInstruments: [{
    creationDate: '2021-04-01T14:34:56.000Z',
    lastModified: '2021-04-01T14:34:56.000Z',
    paymentBankAccount: {},
    paymentCard: {
      cardType: 'Master Card',
      creditCardExpired: false,
      expirationMonth: 1,
      expirationYear: 2030,
      holder: 'Test McTester',
      maskedNumber: '************5454',
      numberLastDigits: '5454',
      validFromMonth: 1,
      validFromYear: 2020
    },
    paymentInstrumentId: 'testcard1',
    paymentMethodId: 'CREDIT_CARD'
  }],
  previousLoginTime: '2021-04-14T13:38:29.778Z',
  previousVisitTime: '2021-04-14T13:38:29.778Z'
};
const mockedGuestCustomer = exports.mockedGuestCustomer = {
  authType: 'guest',
  customerId: 'customerid',
  email: ''
};
const productsResponse = exports.productsResponse = {
  limit: 1,
  data: [{
    currency: 'USD',
    id: '701642811398M',
    imageGroups: [{
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, large',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw3ce02e8b/images/large/PG.10219685.JJ825XX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw3ce02e8b/images/large/PG.10219685.JJ825XX.PZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }, {
        alt: 'Long Sleeve Crew Neck, Fire Red, large',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwdc28ed23/images/large/PG.10219685.JJ825XX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwdc28ed23/images/large/PG.10219685.JJ825XX.BZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'large'
    }, {
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, medium',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8434410d/images/medium/PG.10219685.JJ825XX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8434410d/images/medium/PG.10219685.JJ825XX.PZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }, {
        alt: 'Long Sleeve Crew Neck, Fire Red, medium',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc50f7b16/images/medium/PG.10219685.JJ825XX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc50f7b16/images/medium/PG.10219685.JJ825XX.BZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'medium'
    }, {
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, small',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8173d41b/images/small/PG.10219685.JJ825XX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8173d41b/images/small/PG.10219685.JJ825XX.PZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }, {
        alt: 'Long Sleeve Crew Neck, Fire Red, small',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw426088e2/images/small/PG.10219685.JJ825XX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw426088e2/images/small/PG.10219685.JJ825XX.BZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'small'
    }, {
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, swatch',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwcbc8a4ed/images/swatch/PG.10219685.JJ825XX.CP.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwcbc8a4ed/images/swatch/PG.10219685.JJ825XX.CP.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'swatch'
    }],
    inventory: {
      ats: 89,
      backorderable: false,
      id: 'inventory_m',
      orderable: true,
      preorderable: false,
      stockLevel: 89
    },
    longDescription: 'Wear this long sleeve crew neck top alone, or pair it with a jacket for a classic look.',
    master: {
      masterId: '25517823M',
      orderable: true,
      price: 14.99
    },
    minOrderQuantity: 1,
    name: 'Long Sleeve Crew Neck',
    pageDescription: 'Wear this long sleeve crew neck top alone, or pair it with a jacket for a classic look.',
    pageTitle: 'Long Sleeve Crew Neck',
    price: 14.99,
    productPromotions: [{
      calloutMsg: 'Buy one Long Center Seam Skirt and get 2 tops',
      promotionId: 'ChoiceOfBonusProdect-ProductLevel-ruleBased'
    }],
    shortDescription: 'Wear this long sleeve crew neck top alone, or pair it with a jacket for a classic look.',
    stepQuantity: 1,
    type: {
      variant: true
    },
    upc: '701642811398',
    validFrom: {
      default: '2010-11-18T05:00:00.000Z'
    },
    variants: [{
      orderable: true,
      price: 14.99,
      productId: '701642811398M',
      variationValues: {
        color: 'JJ825XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841227M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841265M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811473M',
      variationValues: {
        color: 'JJI15XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811435M',
      variationValues: {
        color: 'JJG80XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811312M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811237M',
      variationValues: {
        color: 'JJ169XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643342570M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811343M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811404M',
      variationValues: {
        color: 'JJ825XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811336M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811268M',
      variationValues: {
        color: 'JJ169XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070756M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811497M',
      variationValues: {
        color: 'JJI15XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811480M',
      variationValues: {
        color: 'JJI15XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811466M',
      variationValues: {
        color: 'JJG80XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811428M',
      variationValues: {
        color: 'JJ825XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070732M',
      variationValues: {
        color: 'JJ825XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811244M',
      variationValues: {
        color: 'JJ169XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070763M',
      variationValues: {
        color: 'JJG80XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643342587M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811503M',
      variationValues: {
        color: 'JJI15XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811459M',
      variationValues: {
        color: 'JJG80XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070725M',
      variationValues: {
        color: 'JJ169XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841289M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841272M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841241M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811329M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811251M',
      variationValues: {
        color: 'JJ169XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070770M',
      variationValues: {
        color: 'JJI15XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841296M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841258M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811442M',
      variationValues: {
        color: 'JJG80XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811411M',
      variationValues: {
        color: 'JJ825XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841234M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9MD'
      }
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }, {
        name: 'Grey Heather',
        orderable: true,
        value: 'JJ2XNXX'
      }, {
        name: 'Meadow Violet',
        orderable: true,
        value: 'JJ3HDXX'
      }, {
        name: 'Begonia Pink',
        orderable: true,
        value: 'JJ5QZXX'
      }, {
        name: 'Fire Red',
        orderable: true,
        value: 'JJ825XX'
      }, {
        name: 'Sugar',
        orderable: true,
        value: 'JJG80XX'
      }, {
        name: 'White',
        orderable: true,
        value: 'JJI15XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'XS',
        orderable: true,
        value: '9XS'
      }, {
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'L',
        orderable: true,
        value: '9LG'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }],
    variationValues: {
      color: 'JJ825XX',
      size: '9LG'
    },
    c_color: 'JJ825XX',
    c_refinementColor: 'red',
    c_size: '9LG',
    c_width: 'Z'
  }],
  total: 1
};
const mockOrderHistory = exports.mockOrderHistory = {
  limit: 10,
  data: [{
    adjustedMerchandizeTotalTax: 3.15,
    adjustedShippingTotalTax: 0.3,
    billingAddress: {
      address1: '2700 Desoto Way S',
      city: 'Saint Petersburg',
      countryCode: 'US',
      firstName: 'tester',
      fullName: 'tester testing',
      id: '06bca352dc44586ae82cd085c1',
      lastName: 'testing',
      phone: '7275551234',
      postalCode: '33712',
      stateCode: 'FL'
    },
    channelType: 'storefront',
    confirmationStatus: 'not_confirmed',
    createdBy: 'Customer',
    creationDate: '2021-04-06T20:15:40.000Z',
    currency: 'USD',
    customerInfo: {
      customerId: 'customerid',
      customerName: ' testing',
      customerNo: '00149004',
      email: 'tester@test.com'
    },
    customerName: ' testing',
    exportStatus: 'not_exported',
    lastModified: '2021-04-06T20:15:40.000Z',
    merchandizeTotalTax: 3.15,
    notes: {},
    orderNo: '00028011',
    orderToken: 'oiC2ta2H_SZTKspfu0Sc0e41Rp4kaO0oTCSswf7tALw',
    orderTotal: 72.42,
    paymentInstruments: [{
      amount: 0,
      paymentCard: {
        cardType: 'Visa',
        creditCardExpired: false,
        expirationMonth: 1,
        expirationYear: 2030,
        holder: 'tester testing',
        maskedNumber: '************1111',
        numberLastDigits: '1111',
        validFromMonth: 1,
        validFromYear: 2020
      },
      paymentInstrumentId: 'fd4ddecfc5c95b60c7898bbd2a',
      paymentMethodId: 'CREDIT_CARD'
    }],
    paymentStatus: 'not_paid',
    productItems: [{
      adjustedTax: 2.4,
      basePrice: 47.99,
      bonusProductLineItem: false,
      gift: false,
      itemId: '1ae8e9a67e2f6aa2408d87ae37',
      itemText: 'Pleated Bib Long Sleeve Shirt',
      price: 47.99,
      priceAfterItemDiscount: 47.99,
      priceAfterOrderDiscount: 47.99,
      productId: '701642852179M',
      productName: 'Pleated Bib Long Sleeve Shirt',
      quantity: 1,
      shipmentId: 'me',
      tax: 2.4,
      taxBasis: 47.99,
      taxClassId: 'standard',
      taxRate: 0.05
    }, {
      adjustedTax: 0.75,
      basePrice: 14.99,
      bonusProductLineItem: false,
      gift: false,
      itemId: 'e60d5d71f128440894f4b023dd',
      itemText: 'Long Sleeve Crew Neck',
      price: 14.99,
      priceAfterItemDiscount: 14.99,
      priceAfterOrderDiscount: 14.99,
      productId: '701642811398M',
      productName: 'Long Sleeve Crew Neck',
      quantity: 1,
      shipmentId: 'me',
      tax: 0.75,
      taxBasis: 14.99,
      taxClassId: 'standard',
      taxRate: 0.05
    }],
    productSubTotal: 62.98,
    productTotal: 62.98,
    shipments: [{
      adjustedMerchandizeTotalTax: 3.15,
      adjustedShippingTotalTax: 0.3,
      gift: false,
      merchandizeTotalTax: 3.15,
      productSubTotal: 62.98,
      productTotal: 62.98,
      shipmentId: 'me',
      shipmentTotal: 72.42,
      shippingAddress: {
        address1: '2700 Desoto Way S',
        city: 'Saint Petersburg',
        countryCode: 'US',
        firstName: 'tester',
        fullName: 'tester testing',
        id: 'bcb56169768a0ccce114a664e5',
        lastName: 'testing',
        phone: '7275551234',
        postalCode: '33712',
        stateCode: 'FL'
      },
      shippingMethod: {
        description: 'Order received within 7-10 business days',
        id: '001',
        name: 'Ground',
        c_estimatedArrivalTime: '7-10 Business Days'
      },
      shippingStatus: 'not_shipped',
      shippingTotal: 5.99,
      shippingTotalTax: 0.3,
      taxTotal: 3.45
    }],
    shippingItems: [{
      adjustedTax: 0.3,
      basePrice: 5.99,
      itemId: '7d47f50998e2ff9590df8d7daa',
      itemText: 'Shipping',
      price: 5.99,
      priceAfterItemDiscount: 5.99,
      shipmentId: 'me',
      tax: 0.3,
      taxBasis: 5.99,
      taxClassId: 'standard',
      taxRate: 0.05
    }],
    shippingStatus: 'not_shipped',
    shippingTotal: 5.99,
    shippingTotalTax: 0.3,
    siteId: 'RefArch',
    status: 'created',
    taxation: 'net',
    taxTotal: 3.45
  }, {
    adjustedMerchandizeTotalTax: 3.15,
    adjustedShippingTotalTax: 0.3,
    billingAddress: {
      address1: '2700 Desoto Way S',
      city: 'Saint Petersburg',
      countryCode: 'US',
      firstName: 'tester',
      fullName: 'tester testing',
      id: '48692a8d1adb48bdb01e61a7f6',
      lastName: 'testing',
      phone: '7275551234',
      postalCode: '33712',
      stateCode: 'FL'
    },
    channelType: 'storefront',
    confirmationStatus: 'not_confirmed',
    createdBy: 'Customer',
    creationDate: '2021-04-06T19:16:15.000Z',
    currency: 'USD',
    customerInfo: {
      customerId: 'customerid',
      customerName: ' testing',
      customerNo: '00149004',
      email: 'tester@test.com'
    },
    customerName: ' testing',
    exportStatus: 'not_exported',
    lastModified: '2021-04-06T19:16:15.000Z',
    merchandizeTotalTax: 3.15,
    notes: {},
    orderNo: '00028010',
    orderToken: 'ncyXKSHbB0TWkEbESOZpYtJnCpoWyV4EwTH7fp3PV0w',
    orderTotal: 72.42,
    paymentInstruments: [{
      amount: 0,
      paymentCard: {
        cardType: 'Master Card',
        creditCardExpired: false,
        expirationMonth: 1,
        expirationYear: 2030,
        holder: 'tester testing',
        maskedNumber: '************5454',
        numberLastDigits: '5454',
        validFromMonth: 1,
        validFromYear: 2020
      },
      paymentInstrumentId: '2aadecebb15f35913e8ce76a54',
      paymentMethodId: 'CREDIT_CARD'
    }],
    paymentStatus: 'not_paid',
    productItems: [{
      adjustedTax: 2.4,
      basePrice: 47.99,
      bonusProductLineItem: false,
      gift: false,
      itemId: 'b119f1d13193712023c6457ec0',
      itemText: 'Pleated Bib Long Sleeve Shirt',
      price: 47.99,
      priceAfterItemDiscount: 47.99,
      priceAfterOrderDiscount: 47.99,
      productId: '701642852179M',
      productName: 'Pleated Bib Long Sleeve Shirt',
      quantity: 1,
      shipmentId: 'me',
      tax: 2.4,
      taxBasis: 47.99,
      taxClassId: 'standard',
      taxRate: 0.05
    }, {
      adjustedTax: 0.75,
      basePrice: 14.99,
      bonusProductLineItem: false,
      gift: false,
      itemId: '97b033c49c69f2bb72c11b8db7',
      itemText: 'Long Sleeve Crew Neck',
      price: 14.99,
      priceAfterItemDiscount: 14.99,
      priceAfterOrderDiscount: 14.99,
      productId: '701642811398M',
      productName: 'Long Sleeve Crew Neck',
      quantity: 1,
      shipmentId: 'me',
      tax: 0.75,
      taxBasis: 14.99,
      taxClassId: 'standard',
      taxRate: 0.05
    }],
    productSubTotal: 62.98,
    productTotal: 62.98,
    shipments: [{
      adjustedMerchandizeTotalTax: 3.15,
      adjustedShippingTotalTax: 0.3,
      gift: false,
      merchandizeTotalTax: 3.15,
      productSubTotal: 62.98,
      productTotal: 62.98,
      shipmentId: 'me',
      shipmentTotal: 72.42,
      shippingAddress: {
        address1: '2700 Desoto Way S',
        city: 'Saint Petersburg',
        countryCode: 'US',
        firstName: 'tester',
        fullName: 'tester testing',
        id: 'de9186fdf4b0f2c3c0334542d7',
        lastName: 'testing',
        phone: '7275551234',
        postalCode: '33712',
        stateCode: 'FL'
      },
      shippingMethod: {
        description: 'Order received within 7-10 business days',
        id: '001',
        name: 'Ground',
        c_estimatedArrivalTime: '7-10 Business Days'
      },
      shippingStatus: 'not_shipped',
      shippingTotal: 5.99,
      shippingTotalTax: 0.3,
      taxTotal: 3.45
    }],
    shippingItems: [{
      adjustedTax: 0.3,
      basePrice: 5.99,
      itemId: 'fb330a2f980bd715bf5db8607a',
      itemText: 'Shipping',
      price: 5.99,
      priceAfterItemDiscount: 5.99,
      shipmentId: 'me',
      tax: 0.3,
      taxBasis: 5.99,
      taxClassId: 'standard',
      taxRate: 0.05
    }],
    shippingStatus: 'not_shipped',
    shippingTotal: 5.99,
    shippingTotalTax: 0.3,
    siteId: 'RefArch',
    status: 'created',
    taxation: 'net',
    taxTotal: 3.45
  }, {
    adjustedMerchandizeTotalTax: 6.3,
    adjustedShippingTotalTax: 0.4,
    billingAddress: {
      address1: '2700 Desoto Way S',
      city: 'Saint Petersburg',
      countryCode: 'US',
      firstName: 'tester',
      fullName: 'tester testing',
      id: '3f37d99f137e68e118ce0dcd30',
      lastName: 'testing',
      phone: '7275551234',
      postalCode: '33712',
      stateCode: 'FL'
    },
    channelType: 'storefront',
    confirmationStatus: 'not_confirmed',
    createdBy: 'Customer',
    creationDate: '2021-04-06T19:14:32.000Z',
    currency: 'USD',
    customerInfo: {
      customerId: 'customerid',
      customerName: ' testing',
      customerNo: '00149004',
      email: 'tester@test.com'
    },
    customerName: ' testing',
    exportStatus: 'not_exported',
    lastModified: '2021-04-06T19:14:32.000Z',
    merchandizeTotalTax: 6.3,
    notes: {},
    orderNo: '00028009',
    orderToken: '56PXEg-7z6a0OdJslrJI6YLTTlFWzuYP9mL8vU1As3o',
    orderTotal: 140.65,
    paymentInstruments: [{
      amount: 0,
      paymentCard: {
        cardType: 'Master Card',
        creditCardExpired: false,
        expirationMonth: 1,
        expirationYear: 2030,
        holder: 'tester testing',
        maskedNumber: '************5454',
        numberLastDigits: '5454',
        validFromMonth: 1,
        validFromYear: 2020
      },
      paymentInstrumentId: '99e32045955705b49b343b852a',
      paymentMethodId: 'CREDIT_CARD'
    }],
    paymentStatus: 'not_paid',
    productItems: [{
      adjustedTax: 4.8,
      basePrice: 47.99,
      bonusProductLineItem: false,
      gift: false,
      itemId: '1efcc8e1646ff4d36da43a9784',
      itemText: 'Pleated Bib Long Sleeve Shirt',
      price: 95.98,
      priceAfterItemDiscount: 95.98,
      priceAfterOrderDiscount: 95.98,
      productId: '701642852179M',
      productName: 'Pleated Bib Long Sleeve Shirt',
      quantity: 2,
      shipmentId: 'me',
      tax: 4.8,
      taxBasis: 95.98,
      taxClassId: 'standard',
      taxRate: 0.05
    }, {
      adjustedTax: 1.5,
      basePrice: 14.99,
      bonusProductLineItem: false,
      gift: false,
      itemId: 'e0553dd676331dc8de59c0784a',
      itemText: 'Long Sleeve Crew Neck',
      price: 29.98,
      priceAfterItemDiscount: 29.98,
      priceAfterOrderDiscount: 29.98,
      productId: '701642811398M',
      productName: 'Long Sleeve Crew Neck',
      quantity: 2,
      shipmentId: 'me',
      tax: 1.5,
      taxBasis: 29.98,
      taxClassId: 'standard',
      taxRate: 0.05
    }],
    productSubTotal: 125.96,
    productTotal: 125.96,
    shipments: [{
      adjustedMerchandizeTotalTax: 6.3,
      adjustedShippingTotalTax: 0.4,
      gift: false,
      merchandizeTotalTax: 6.3,
      productSubTotal: 125.96,
      productTotal: 125.96,
      shipmentId: 'me',
      shipmentTotal: 140.65,
      shippingAddress: {
        address1: '2700 Desoto Way S',
        city: 'Saint Petersburg',
        countryCode: 'US',
        firstName: 'tester',
        fullName: 'tester testing',
        id: '7cc3b6ea84774193fde332c61a',
        lastName: 'testing',
        phone: '7275551234',
        postalCode: '33712',
        stateCode: 'FL'
      },
      shippingMethod: {
        description: 'Order received within 7-10 business days',
        id: '001',
        name: 'Ground',
        c_estimatedArrivalTime: '7-10 Business Days'
      },
      shippingStatus: 'not_shipped',
      shippingTotal: 7.99,
      shippingTotalTax: 0.4,
      taxTotal: 6.7
    }],
    shippingItems: [{
      adjustedTax: 0.4,
      basePrice: 7.99,
      itemId: '1a72125aef737dbb2e6ec96dd9',
      itemText: 'Shipping',
      price: 7.99,
      priceAfterItemDiscount: 7.99,
      shipmentId: 'me',
      tax: 0.4,
      taxBasis: 7.99,
      taxClassId: 'standard',
      taxRate: 0.05
    }],
    shippingStatus: 'not_shipped',
    shippingTotal: 7.99,
    shippingTotalTax: 0.4,
    siteId: 'RefArch',
    status: 'created',
    taxation: 'net',
    taxTotal: 6.7
  }],
  offset: 0,
  total: 20
};
const mockOrderProducts = exports.mockOrderProducts = {
  limit: 2,
  data: [{
    currency: 'USD',
    id: '701642852179M',
    imageGroups: [{
      images: [{
        alt: 'Pleated Bib Long Sleeve Shirt, Silver Grey, large',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw6dc64ae1/images/large/PG.10201818.JJ1ANXX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw6dc64ae1/images/large/PG.10201818.JJ1ANXX.PZ.jpg',
        title: 'Pleated Bib Long Sleeve Shirt, Silver Grey'
      }, {
        alt: 'Pleated Bib Long Sleeve Shirt, Silver Grey, large',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw6c256020/images/large/PG.10201818.JJ1ANXX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw6c256020/images/large/PG.10201818.JJ1ANXX.BZ.jpg',
        title: 'Pleated Bib Long Sleeve Shirt, Silver Grey'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ1ANXX'
        }]
      }],
      viewType: 'large'
    }, {
      images: [{
        alt: 'Pleated Bib Long Sleeve Shirt, Silver Grey, medium',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwad2ef842/images/medium/PG.10201818.JJ1ANXX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwad2ef842/images/medium/PG.10201818.JJ1ANXX.PZ.jpg',
        title: 'Pleated Bib Long Sleeve Shirt, Silver Grey'
      }, {
        alt: 'Pleated Bib Long Sleeve Shirt, Silver Grey, medium',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwca64fee1/images/medium/PG.10201818.JJ1ANXX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwca64fee1/images/medium/PG.10201818.JJ1ANXX.BZ.jpg',
        title: 'Pleated Bib Long Sleeve Shirt, Silver Grey'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ1ANXX'
        }]
      }],
      viewType: 'medium'
    }, {
      images: [{
        alt: 'Pleated Bib Long Sleeve Shirt, Silver Grey, small',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw2ecc9f4b/images/small/PG.10201818.JJ1ANXX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw2ecc9f4b/images/small/PG.10201818.JJ1ANXX.PZ.jpg',
        title: 'Pleated Bib Long Sleeve Shirt, Silver Grey'
      }, {
        alt: 'Pleated Bib Long Sleeve Shirt, Silver Grey, small',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc4b732e9/images/small/PG.10201818.JJ1ANXX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc4b732e9/images/small/PG.10201818.JJ1ANXX.BZ.jpg',
        title: 'Pleated Bib Long Sleeve Shirt, Silver Grey'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ1ANXX'
        }]
      }],
      viewType: 'small'
    }, {
      images: [{
        alt: 'Pleated Bib Long Sleeve Shirt, Silver Grey, swatch',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc39b144c/images/swatch/PG.10201818.JJ1ANXX.CP.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc39b144c/images/swatch/PG.10201818.JJ1ANXX.CP.jpg',
        title: 'Pleated Bib Long Sleeve Shirt, Silver Grey'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ1ANXX'
        }]
      }],
      viewType: 'swatch'
    }],
    inventory: {
      ats: 99,
      backorderable: false,
      id: 'inventory_m',
      orderable: true,
      preorderable: false,
      stockLevel: 99
    },
    longDescription: 'This is a feminine take on a tuxedo classic.  Pair it with a pair of Commerce Cloud Store slacks.',
    master: {
      masterId: '25518344M',
      orderable: true,
      price: 47.99
    },
    minOrderQuantity: 1,
    name: 'Pleated Bib Long Sleeve Shirt',
    pageDescription: 'This is a feminine take on a tuxedo classic.  Pair it with a pair of Commerce Cloud Store slacks.',
    pageTitle: 'Pleated Bib Long Sleeve Shirt',
    price: 47.99,
    productPromotions: [{
      calloutMsg: 'Buy one Long Center Seam Skirt and get 2 tops',
      promotionId: 'ChoiceOfBonusProdect-ProductLevel-ruleBased'
    }],
    shortDescription: 'This is a feminine take on a tuxedo classic.  Pair it with a pair of Commerce Cloud Store slacks.',
    stepQuantity: 1,
    type: {
      variant: true
    },
    upc: '701642852179',
    validFrom: {
      default: '2010-10-21T04:00:00.000Z'
    },
    variants: [{
      orderable: true,
      price: 47.99,
      productId: '701642852179M',
      variationValues: {
        color: 'JJ1ANXX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 47.99,
      productId: '701642852209M',
      variationValues: {
        color: 'JJ1ANXX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 47.99,
      productId: '701642852193M',
      variationValues: {
        color: 'JJ1ANXX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 47.99,
      productId: '701642852186M',
      variationValues: {
        color: 'JJ1ANXX',
        size: '9MD'
      }
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Silver Grey',
        orderable: true,
        value: 'JJ1ANXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'L',
        orderable: true,
        value: '9LG'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }],
    variationValues: {
      color: 'JJ1ANXX',
      size: '9LG'
    },
    c_color: 'JJ1ANXX',
    c_isNewtest: true,
    c_isSale: true,
    c_refinementColor: 'grey',
    c_size: '9LG',
    c_width: 'Z'
  }, {
    currency: 'USD',
    id: '701642811398M',
    imageGroups: [{
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, large',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw3ce02e8b/images/large/PG.10219685.JJ825XX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw3ce02e8b/images/large/PG.10219685.JJ825XX.PZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }, {
        alt: 'Long Sleeve Crew Neck, Fire Red, large',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwdc28ed23/images/large/PG.10219685.JJ825XX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwdc28ed23/images/large/PG.10219685.JJ825XX.BZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'large'
    }, {
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, medium',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8434410d/images/medium/PG.10219685.JJ825XX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8434410d/images/medium/PG.10219685.JJ825XX.PZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }, {
        alt: 'Long Sleeve Crew Neck, Fire Red, medium',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc50f7b16/images/medium/PG.10219685.JJ825XX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwc50f7b16/images/medium/PG.10219685.JJ825XX.BZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'medium'
    }, {
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, small',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8173d41b/images/small/PG.10219685.JJ825XX.PZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8173d41b/images/small/PG.10219685.JJ825XX.PZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }, {
        alt: 'Long Sleeve Crew Neck, Fire Red, small',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw426088e2/images/small/PG.10219685.JJ825XX.BZ.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw426088e2/images/small/PG.10219685.JJ825XX.BZ.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'small'
    }, {
      images: [{
        alt: 'Long Sleeve Crew Neck, Fire Red, swatch',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwcbc8a4ed/images/swatch/PG.10219685.JJ825XX.CP.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwcbc8a4ed/images/swatch/PG.10219685.JJ825XX.CP.jpg',
        title: 'Long Sleeve Crew Neck, Fire Red'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'JJ825XX'
        }]
      }],
      viewType: 'swatch'
    }],
    inventory: {
      ats: 34,
      backorderable: false,
      id: 'inventory_m',
      orderable: true,
      preorderable: false,
      stockLevel: 34
    },
    longDescription: 'Wear this long sleeve crew neck top alone, or pair it with a jacket for a classic look.',
    master: {
      masterId: '25517823M',
      orderable: true,
      price: 14.99
    },
    minOrderQuantity: 1,
    name: 'Long Sleeve Crew Neck',
    pageDescription: 'Wear this long sleeve crew neck top alone, or pair it with a jacket for a classic look.',
    pageTitle: 'Long Sleeve Crew Neck',
    price: 14.99,
    productPromotions: [{
      calloutMsg: 'Buy one Long Center Seam Skirt and get 2 tops',
      promotionId: 'ChoiceOfBonusProdect-ProductLevel-ruleBased'
    }],
    shortDescription: 'Wear this long sleeve crew neck top alone, or pair it with a jacket for a classic look.',
    stepQuantity: 1,
    type: {
      variant: true
    },
    upc: '701642811398',
    validFrom: {
      default: '2010-11-18T05:00:00.000Z'
    },
    variants: [{
      orderable: true,
      price: 14.99,
      productId: '701642811398M',
      variationValues: {
        color: 'JJ825XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841227M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841265M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811473M',
      variationValues: {
        color: 'JJI15XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811435M',
      variationValues: {
        color: 'JJG80XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811312M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811237M',
      variationValues: {
        color: 'JJ169XX',
        size: '9LG'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643342570M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811343M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811404M',
      variationValues: {
        color: 'JJ825XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811336M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811268M',
      variationValues: {
        color: 'JJ169XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070756M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811497M',
      variationValues: {
        color: 'JJI15XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811480M',
      variationValues: {
        color: 'JJI15XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811466M',
      variationValues: {
        color: 'JJG80XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811428M',
      variationValues: {
        color: 'JJ825XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070732M',
      variationValues: {
        color: 'JJ825XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811244M',
      variationValues: {
        color: 'JJ169XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070763M',
      variationValues: {
        color: 'JJG80XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643342587M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811503M',
      variationValues: {
        color: 'JJI15XX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811459M',
      variationValues: {
        color: 'JJG80XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070725M',
      variationValues: {
        color: 'JJ169XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841289M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841272M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841241M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811329M',
      variationValues: {
        color: 'JJ2XNXX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811251M',
      variationValues: {
        color: 'JJ169XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701643070770M',
      variationValues: {
        color: 'JJI15XX',
        size: '9XS'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841296M',
      variationValues: {
        color: 'JJ5QZXX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841258M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9XL'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811442M',
      variationValues: {
        color: 'JJG80XX',
        size: '9MD'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642811411M',
      variationValues: {
        color: 'JJ825XX',
        size: '9SM'
      }
    }, {
      orderable: true,
      price: 14.99,
      productId: '701642841234M',
      variationValues: {
        color: 'JJ3HDXX',
        size: '9MD'
      }
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }, {
        name: 'Grey Heather',
        orderable: true,
        value: 'JJ2XNXX'
      }, {
        name: 'Meadow Violet',
        orderable: true,
        value: 'JJ3HDXX'
      }, {
        name: 'Begonia Pink',
        orderable: true,
        value: 'JJ5QZXX'
      }, {
        name: 'Fire Red',
        orderable: true,
        value: 'JJ825XX'
      }, {
        name: 'Sugar',
        orderable: true,
        value: 'JJG80XX'
      }, {
        name: 'White',
        orderable: true,
        value: 'JJI15XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'XS',
        orderable: true,
        value: '9XS'
      }, {
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'L',
        orderable: true,
        value: '9LG'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }],
    variationValues: {
      color: 'JJ825XX',
      size: '9LG'
    },
    c_color: 'JJ825XX',
    c_refinementColor: 'red',
    c_size: '9LG',
    c_width: 'Z'
  }],
  total: 2
};
const mockedCustomerProductLists = exports.mockedCustomerProductLists = {
  limit: 1,
  data: [{
    creationDate: '2021-06-12T00:09:00.000Z',
    customerProductListItems: [{
      id: 'b41ad6634e83fc9673625bf087',
      priority: 1,
      productId: 'apple-ipod-nano-green-16gM',
      public: false,
      purchasedQuantity: 0,
      quantity: 1,
      type: 'product'
    }],
    event: {},
    id: 'c1b0edb2ad6fcfb153044ef3b0',
    lastModified: '2021-06-30T04:11:12.602Z',
    public: false,
    name: 'PWA wishlist',
    type: 'wish_list'
  }],
  total: 1
};
const mockedEmptyCustomerProductList = exports.mockedEmptyCustomerProductList = {
  limit: 1,
  data: [{
    creationDate: '2021-06-12T00:09:00.000Z',
    customerProductListItems: [],
    event: {},
    id: 'c1b0edb2ad6fcfb153044ef3b0',
    lastModified: '2021-06-30T04:11:12.602Z',
    public: false,
    type: 'wish_list'
  }],
  total: 1
};
const mockedCustomerProductListsDetails = exports.mockedCustomerProductListsDetails = {
  limit: 1,
  data: [{
    brand: 'Apple',
    currency: 'USD',
    id: 'apple-ipod-nano-green-16gM',
    imageGroups: [{
      images: [{
        alt: 'Apple iPod Nano, Green, large',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-electronics-m-catalog/default/dw26470cbd/images/large/ipod-nano-green.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-electronics-m-catalog/default/dw26470cbd/images/large/ipod-nano-green.jpg',
        title: 'Apple iPod Nano, Green'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'Green'
        }]
      }],
      viewType: 'large'
    }, {
      images: [{
        alt: 'Apple iPod Nano, Green, medium',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-electronics-m-catalog/default/dw610652b7/images/medium/ipod-nano-green.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-electronics-m-catalog/default/dw610652b7/images/medium/ipod-nano-green.jpg',
        title: 'Apple iPod Nano, Green'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'Green'
        }]
      }],
      viewType: 'medium'
    }, {
      images: [{
        alt: 'Apple iPod Nano, Green, small',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-electronics-m-catalog/default/dw09f0fd49/images/small/ipod-nano-green.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-electronics-m-catalog/default/dw09f0fd49/images/small/ipod-nano-green.jpg',
        title: 'Apple iPod Nano, Green'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'Green'
        }]
      }],
      viewType: 'small'
    }, {
      images: [{
        alt: 'Apple iPod Nano, Green, swatch',
        disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-electronics-m-catalog/default/dw849cd37f/images/swatch/green.jpg',
        link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-electronics-m-catalog/default/dw849cd37f/images/swatch/green.jpg',
        title: 'Apple iPod Nano, Green'
      }],
      variationAttributes: [{
        id: 'color',
        values: [{
          value: 'Green'
        }]
      }],
      viewType: 'swatch'
    }],
    inventory: {
      ats: 10,
      backorderable: true,
      id: 'inventory_m',
      inStockDate: '2009-03-31T00:00:00.000Z',
      orderable: true,
      preorderable: false,
      stockLevel: 0
    },
    longDescription: 'Supports MP3 (up to 320 Kbps), MP3 VBR, AAC (up to 320 Kbps), Protected AAC (iTunes Music Store), Audible (formats 2, 3, 4), AIFF, Apple Lossless and WAV audio formats, plus BMP, JPEG, GIF, TIFF, PNG and PSD (Mac only) image formats; podcasting support',
    master: {
      masterId: 'apple-ipod-nanoM',
      orderable: true,
      price: 119.0
    },
    minOrderQuantity: 1,
    name: 'Apple iPod Nano',
    pageDescription: 'The all new iPod nano has a curved aluminum and glass design and stunning new features. The Genius music feature helps you find music to fit your mood. With the built-in accelerometer, you can rotate the nano to flip through album art with Cover Flow. Plus, view photos and videos in either portrait or landscape.',
    pageKeywords: 'Apple, iPod, Nano, MP3, Music Player',
    pageTitle: 'Apple iPod Nano',
    price: 199.0,
    pricePerUnit: 199.0,
    productPromotions: [{
      calloutMsg: '$50offOrderCountAbove5',
      promotionId: '$50offOrderCountAbove5'
    }],
    shortDescription: 'The all new iPod nano has a curved aluminum and glass design and stunning new features. The Genius music \r\nfeature helps you find music to fit your mood. With the built-in accelerometer, you can rotate the nano to flip through album art with \r\nCover Flow. Plus, view photos and videos in either portrait or landscape.',
    stepQuantity: 1,
    type: {
      variant: true
    },
    unitMeasure: '',
    unitQuantity: 0,
    variants: [{
      orderable: true,
      price: 149.0,
      productId: 'apple-ipod-nano-silver-8gM',
      variationValues: {
        color: 'Silver',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 149.0,
      productId: 'apple-ipod-nano-black-8gM',
      variationValues: {
        color: 'Black',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 149.0,
      productId: 'apple-ipod-nano-purple-8gM',
      variationValues: {
        color: 'Purple',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 149.0,
      productId: 'apple-ipod-nano-blue-8gM',
      variationValues: {
        color: 'Blue',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 149.0,
      productId: 'apple-ipod-nano-green-8gM',
      variationValues: {
        color: 'Green',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 119.0,
      productId: 'apple-ipod-nano-yellow-8gM',
      variationValues: {
        color: 'Yellow',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 149.0,
      productId: 'apple-ipod-nano-orange-8gM',
      variationValues: {
        color: 'Orange',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 119.0,
      productId: 'apple-ipod-nano-red-8gM',
      variationValues: {
        color: 'Red',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 149.0,
      productId: 'apple-ipod-nano-fuscia-8gM',
      variationValues: {
        color: 'Fuscia',
        memorySize: '8 GB'
      }
    }, {
      orderable: true,
      price: 199.0,
      productId: 'apple-ipod-nano-silver-16gM',
      variationValues: {
        color: 'Silver',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 199.0,
      productId: 'apple-ipod-nano-black-16gM',
      variationValues: {
        color: 'Black',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 199.0,
      productId: 'apple-ipod-nano-purple-16gM',
      variationValues: {
        color: 'Purple',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 159.0,
      productId: 'apple-ipod-nano-blue-16gM',
      variationValues: {
        color: 'Blue',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 199.0,
      productId: 'apple-ipod-nano-green-16gM',
      variationValues: {
        color: 'Green',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 199.0,
      productId: 'apple-ipod-nano-yellow-16gM',
      variationValues: {
        color: 'Yellow',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 159.0,
      productId: 'apple-ipod-nano-orange-16gM',
      variationValues: {
        color: 'Orange',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 199.0,
      productId: 'apple-ipod-nano-red-16gM',
      variationValues: {
        color: 'Red',
        memorySize: '16 GB'
      }
    }, {
      orderable: true,
      price: 199.0,
      productId: 'apple-ipod-nano-fuscia-16gM',
      variationValues: {
        color: 'Fuscia',
        memorySize: '16 GB'
      }
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Silver',
        orderable: true,
        value: 'Silver'
      }, {
        name: 'Black',
        orderable: true,
        value: 'Black'
      }, {
        name: 'Purple',
        orderable: true,
        value: 'Purple'
      }, {
        name: 'Blue',
        orderable: true,
        value: 'Blue'
      }, {
        name: 'Green',
        orderable: true,
        value: 'Green'
      }, {
        name: 'Yellow',
        orderable: true,
        value: 'Yellow'
      }, {
        name: 'Orange',
        orderable: true,
        value: 'Orange'
      }, {
        name: 'Red',
        orderable: true,
        value: 'Red'
      }, {
        name: 'Fuscia',
        orderable: true,
        value: 'Fuscia'
      }]
    }, {
      id: 'memorySize',
      name: 'Memory Size',
      values: [{
        name: '8 GB',
        orderable: true,
        value: '8 GB'
      }, {
        name: '16 GB',
        orderable: true,
        value: '16 GB'
      }]
    }],
    variationValues: {
      color: 'Green',
      memorySize: '16 GB'
    },
    c_batteryLife: '24 hours',
    c_batteryType: 'Lithium Ion',
    c_color: 'Green',
    c_dimDepth: '0.24 inches',
    c_dimHeight: '3.6 inches',
    c_dimWeight: '1.3 ounces',
    c_dimWidth: '1.5 inches',
    c_displaySize: '2 inches',
    c_mediaFormat: ['0010', '0020', '0030'],
    c_memorySize: '16 GB',
    c_musicStorage: '4,000 songs',
    c_portableAudioType: ['0010', '0020'],
    c_refinementColor: 'green',
    c_resolution: '320 x 240',
    c_tabDescription: 'The all new iPod nano has a curved aluminum and glass design and stunning new features. The Genius music feature helps you find music to fit your mood. With the built-in accelerometer, you can rotate the nano to flip through album art with Cover Flow. Plus, view photos and videos in either portrait or landscape.',
    c_tabDetails: 'Supports MP3 (up to 320 Kbps), MP3 VBR, AAC (up to 320 Kbps), Protected AAC (iTunes Music Store), Audible (formats 2, 3, 4), AIFF, Apple Lossless and WAV audio formats, plus BMP, JPEG, GIF, TIFF, PNG and PSD (Mac only) image formats; podcasting support',
    c_videoStorage: '16 hours'
  }],
  total: 1
};
const mockCategory = exports.mockCategory = {
  id: 'mens',
  name: 'Mens',
  pageDescription: "Men's range. Hard-wearing boots, jackets and clothing for unbeatable comfort day in, day out. Practical, easy-to-wear styles wherever you're headed.",
  pageKeywords: 'mens boots, mens shoes, mens clothing, mens apparel, mens jackets',
  pageTitle: "Men's Footwear, Outerwear, Clothing & Accessories",
  parentCategoryId: 'root',
  c_showInMenu: true,
  loaded: true,
  image: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-storefront-catalog-m-en/default/dw56b28e03/images/slot/sub_banners/cat-banner-mens-suits.jpg'
};
const mockCategories = exports.mockCategories = {
  root: {
    categories: [{
      id: 'mens',
      name: 'Mens',
      pageDescription: "Men's range. Hard-wearing boots, jackets and clothing for unbeatable comfort day in, day out. Practical, easy-to-wear styles wherever you're headed.",
      pageKeywords: 'mens boots, mens shoes, mens clothing, mens apparel, mens jackets',
      pageTitle: "Men's Footwear, Outerwear, Clothing & Accessories",
      parentCategoryId: 'root',
      c_showInMenu: true,
      image: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-storefront-catalog-m-en/default/dw56b28e03/images/slot/sub_banners/cat-banner-mens-suits.jpg'
    }],
    id: 'root',
    name: 'Storefront Catalog - Non-EN'
  }
};
const mockProductSearch = exports.mockProductSearch = {
  limit: 25,
  hits: [{
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Slim Skirt With Back Kick Pleats, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw1c5f9222/images/large/PG.10221626.JJ3WCXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw1c5f9222/images/large/PG.10221626.JJ3WCXX.PZ.jpg',
      title: 'Slim Skirt With Back Kick Pleats, '
    },
    orderable: true,
    price: 73.99,
    productId: '25588993M',
    productName: 'Slim Skirt With Back Kick Pleats',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644042639M'
    },
    representedProducts: [{
      id: '701644042639M'
    }, {
      id: '701644042622M'
    }, {
      id: '701644042653M'
    }, {
      id: '701644042646M'
    }, {
      id: '701644042592M'
    }, {
      id: '701644042608M'
    }, {
      id: '701644042615M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Pull On Neutral Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw22e88fa3/images/large/PG.10224484.JJ0CZXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw22e88fa3/images/large/PG.10224484.JJ0CZXX.PZ.jpg',
      title: 'Pull On Neutral Pant, '
    },
    orderable: true,
    price: 69.0,
    productId: '25565094M',
    productName: 'Pull On Neutral Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643458462M'
    },
    representedProducts: [{
      id: '701643458462M'
    }, {
      id: '701643458509M'
    }, {
      id: '701643458479M'
    }, {
      id: '701643458493M'
    }, {
      id: '701643458486M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black & Sugar',
        orderable: true,
        value: 'JJ0CZXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'XS',
        orderable: true,
        value: '9XS'
      }, {
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'L',
        orderable: true,
        value: '9LG'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Washable Linen Slim Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab413b1b/images/large/PG.10243116.JJ2DGXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab413b1b/images/large/PG.10243116.JJ2DGXX.PZ.jpg',
      title: 'Washable Linen Slim Pant, '
    },
    orderable: true,
    price: 89.0,
    productId: '25593301M',
    productName: 'Washable Linen Slim Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644068349M'
    },
    representedProducts: [{
      id: '701644068349M'
    }, {
      id: '701644068301M'
    }, {
      id: '701644068318M'
    }, {
      id: '701644068356M'
    }, {
      id: '701644068325M'
    }, {
      id: '701644068332M'
    }, {
      id: '701644068363M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Classic Crop Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwbce5c490/images/large/PG.10232332.JJ169XX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwbce5c490/images/large/PG.10232332.JJ169XX.PZ.jpg',
      title: 'Classic Crop Pant, '
    },
    orderable: true,
    price: 69.0,
    productId: '25564454M',
    productName: 'Classic Crop Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643370818M'
    },
    representedProducts: [{
      id: '701643370818M'
    }, {
      id: '701643370801M'
    }, {
      id: '701643370825M'
    }, {
      id: '701643370849M'
    }, {
      id: '701643370832M'
    }, {
      id: '701643370856M'
    }, {
      id: '701643370795M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Slim Floral Skirt, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwea207073/images/large/PG.10225656.JJ3WDXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwea207073/images/large/PG.10225656.JJ3WDXX.PZ.jpg',
      title: 'Slim Floral Skirt, '
    },
    orderable: true,
    price: 73.99,
    productId: '25589419M',
    productName: 'Slim Floral Skirt',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643415397M'
    },
    representedProducts: [{
      id: '701643415397M'
    }, {
      id: '701643415434M'
    }, {
      id: '701643415403M'
    }, {
      id: '701643415410M'
    }, {
      id: '701643415380M'
    }, {
      id: '701643415427M'
    }, {
      id: '701643415441M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black Multi',
        orderable: true,
        value: 'JJ3WDXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Trouser Leg Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56926d5f/images/large/PG.10207088.JJ169XX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw56926d5f/images/large/PG.10207088.JJ169XX.PZ.jpg',
      title: 'Trouser Leg Pant, '
    },
    orderable: true,
    price: 47.99,
    productId: '25518746M',
    productName: 'Trouser Leg Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701642867753M'
    },
    representedProducts: [{
      id: '701642867753M'
    }, {
      id: '701642867777M'
    }, {
      id: '701642867715M'
    }, {
      id: '701642867722M'
    }, {
      id: '701642867746M'
    }, {
      id: '701642867760M'
    }, {
      id: '701642867739M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Tribal Inspired Slim Skirt, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0ecd95d1/images/large/PG.10244521.JJ3WDXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0ecd95d1/images/large/PG.10244521.JJ3WDXX.PZ.jpg',
      title: 'Tribal Inspired Slim Skirt, '
    },
    orderable: true,
    price: 73.99,
    productId: '25762759M',
    productName: 'Tribal Inspired Slim Skirt',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643636334M'
    },
    representedProducts: [{
      id: '701643636334M'
    }, {
      id: '701643636365M'
    }, {
      id: '701643636372M'
    }, {
      id: '701643636310M'
    }, {
      id: '701643636341M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black Multi',
        orderable: true,
        value: 'JJ3WDXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Relaxed Fit Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw4eee8da9/images/large/PG.10228765.JJ169XX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw4eee8da9/images/large/PG.10228765.JJ169XX.PZ.jpg',
      title: 'Relaxed Fit Pant, '
    },
    orderable: true,
    price: 69.0,
    productId: '25565572M',
    productName: 'Relaxed Fit Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644025151M'
    },
    representedProducts: [{
      id: '701644025151M'
    }, {
      id: '701644025182M'
    }, {
      id: '701644025175M'
    }, {
      id: '701644025168M'
    }, {
      id: '701644025199M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'XS',
        orderable: true,
        value: '9XS'
      }, {
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'L',
        orderable: true,
        value: '9LG'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: '5 Pocket Cuffed Capri, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwb4de158c/images/large/PG.60113984.JJ169XX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwb4de158c/images/large/PG.60113984.JJ169XX.PZ.jpg',
      title: '5 Pocket Cuffed Capri, '
    },
    orderable: true,
    price: 49.0,
    productId: '25688156M',
    productName: '5 Pocket Cuffed Capri',
    productType: {
      master: true
    },
    representedProduct: {
      id: '609717696089M'
    },
    representedProducts: [{
      id: '609717696089M'
    }, {
      id: '609717696041M'
    }, {
      id: '609717696096M'
    }, {
      id: '609717696027M'
    }, {
      id: '609717696102M'
    }, {
      id: '609717696034M'
    }, {
      id: '609717696058M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Pleated Skirt., , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwf573a20b/images/large/PG.10255878.JJ3WCXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwf573a20b/images/large/PG.10255878.JJ3WCXX.PZ.jpg',
      title: 'Pleated Skirt., '
    },
    orderable: true,
    price: 109.0,
    productId: '25697392M',
    productName: 'Pleated Skirt.',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644443054M'
    },
    representedProducts: [{
      id: '701644443054M'
    }, {
      id: '701644443061M'
    }, {
      id: '701644443085M'
    }, {
      id: '701644443078M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'L',
        orderable: true,
        value: '9LG'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Classic Glen Plaid Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw6d0a44b0/images/large/PG.10233641.JJ3WRXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw6d0a44b0/images/large/PG.10233641.JJ3WRXX.PZ.jpg',
      title: 'Classic Glen Plaid Pant, '
    },
    orderable: true,
    price: 80.99,
    productId: '25589157M',
    productName: 'Classic Glen Plaid Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643409747M'
    },
    representedProducts: [{
      id: '701643409747M'
    }, {
      id: '701643409716M'
    }, {
      id: '701643409761M'
    }, {
      id: '701643409723M'
    }, {
      id: '701643409730M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black & Ivory',
        orderable: true,
        value: 'JJ3WRXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Long Pleated Skirt, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw26c8763f/images/large/PG.10239110.JJ3WCXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw26c8763f/images/large/PG.10239110.JJ3WCXX.PZ.jpg',
      title: 'Long Pleated Skirt, '
    },
    orderable: true,
    price: 109.0,
    productId: '25589795M',
    productName: 'Long Pleated Skirt',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644066987M'
    },
    representedProducts: [{
      id: '701644066987M'
    }, {
      id: '701644066994M'
    }, {
      id: '701644067007M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Pleated Skirt With Embroidery., , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07b70fb1/images/large/PG.10245262.JJ3WCXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07b70fb1/images/large/PG.10245262.JJ3WCXX.PZ.jpg',
      title: 'Pleated Skirt With Embroidery., '
    },
    orderable: true,
    price: 149.0,
    productId: '25696693M',
    productName: 'Pleated Skirt With Embroidery.',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644335342M'
    },
    representedProducts: [{
      id: '701644335342M'
    }, {
      id: '701644335397M'
    }, {
      id: '701644335373M'
    }, {
      id: '701644335380M'
    }, {
      id: '701644335366M'
    }, {
      id: '701644335359M'
    }, {
      id: '701644335403M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Straight Ankle Pant., , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwdaccb91d/images/large/PG.10246102.JJ0DDXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwdaccb91d/images/large/PG.10246102.JJ0DDXX.PZ.jpg',
      title: 'Straight Ankle Pant., '
    },
    orderable: true,
    price: 79.0,
    productId: '25697630M',
    productName: 'Straight Ankle Pant.',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644389383M'
    },
    representedProducts: [{
      id: '701644389383M'
    }, {
      id: '701644389369M'
    }, {
      id: '701644389413M'
    }, {
      id: '701644389420M'
    }, {
      id: '701644389376M'
    }, {
      id: '701644389437M'
    }, {
      id: '701644389390M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black & White',
        orderable: true,
        value: 'JJ0DDXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Classic Tweed Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8ae5dac1/images/large/PG.10208897.JJ0QRXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8ae5dac1/images/large/PG.10208897.JJ0QRXX.PZ.jpg',
      title: 'Classic Tweed Pant, '
    },
    orderable: true,
    price: 80.99,
    productId: '25502027M',
    productName: 'Classic Tweed Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701642884323M'
    },
    representedProducts: [{
      id: '701642884323M'
    }, {
      id: '701642884347M'
    }, {
      id: '701642884309M'
    }, {
      id: '701642884354M'
    }, {
      id: '701642884361M'
    }, {
      id: '701642884330M'
    }, {
      id: '701642884316M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Laurel Multi',
        orderable: true,
        value: 'JJ0QRXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Ribbed Pleated Skirt, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa7953e0e/images/large/PG.10218193.JJ0NLE5.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwa7953e0e/images/large/PG.10218193.JJ0NLE5.PZ.jpg',
      title: 'Ribbed Pleated Skirt, '
    },
    orderable: true,
    price: 68.99,
    productId: '25503070M',
    productName: 'Ribbed Pleated Skirt',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643037582M'
    },
    representedProducts: [{
      id: '701643037582M'
    }, {
      id: '701643037612M'
    }, {
      id: '701643037599M'
    }, {
      id: '701643037605M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Laurel',
        orderable: true,
        value: 'JJ0NLE5'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: 'S',
        orderable: true,
        value: '9SM'
      }, {
        name: 'M',
        orderable: true,
        value: '9MD'
      }, {
        name: 'L',
        orderable: true,
        value: '9LG'
      }, {
        name: 'XL',
        orderable: true,
        value: '9XL'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Bootleg Trouser, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8641f0b8/images/large/PG.10204133.JJ0CZXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8641f0b8/images/large/PG.10204133.JJ0CZXX.PZ.jpg',
      title: 'Bootleg Trouser, '
    },
    orderable: true,
    price: 68.99,
    productId: '25518397M',
    productName: 'Bootleg Trouser',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701642853077M'
    },
    representedProducts: [{
      id: '701642853077M'
    }, {
      id: '701642853084M'
    }, {
      id: '701642853107M'
    }, {
      id: '701642853145M'
    }, {
      id: '701642853121M'
    }, {
      id: '701642853091M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black & Sugar',
        orderable: true,
        value: 'JJ0CZXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Wide Leg Pant., , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw2c21e32c/images/large/PG.10245233.JJ3WDXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw2c21e32c/images/large/PG.10245233.JJ3WDXX.PZ.jpg',
      title: 'Wide Leg Pant., '
    },
    orderable: true,
    price: 119.0,
    productId: '25696685M',
    productName: 'Wide Leg Pant.',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644334871M'
    },
    representedProducts: [{
      id: '701644334871M'
    }, {
      id: '701644334895M'
    }, {
      id: '701644334864M'
    }, {
      id: '701644334901M'
    }, {
      id: '701644334840M'
    }, {
      id: '701644334857M'
    }, {
      id: '701644334888M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black Multi',
        orderable: true,
        value: 'JJ3WDXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Eyelet Skirt., , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9efe5554/images/large/PG.10253481.JJ169XX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9efe5554/images/large/PG.10253481.JJ169XX.PZ.jpg',
      title: 'Eyelet Skirt., '
    },
    orderable: true,
    price: 89.0,
    productId: '25697659M',
    productName: 'Eyelet Skirt.',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701644390952M'
    },
    representedProducts: [{
      id: '701644390952M'
    }, {
      id: '701644390891M'
    }, {
      id: '701644390907M'
    }, {
      id: '701644390921M'
    }, {
      id: '701644390945M'
    }, {
      id: '701644390914M'
    }, {
      id: '701644390969M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Washable Wool Classic Straight Skirt , , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwf6272a34/images/large/PG.10176157.JJ5AJXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwf6272a34/images/large/PG.10176157.JJ5AJXX.PZ.jpg',
      title: 'Washable Wool Classic Straight Skirt , '
    },
    orderable: true,
    price: 89.0,
    productId: '25328702M',
    productName: 'Washable Wool Classic Straight Skirt ',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701641312858M'
    },
    representedProducts: [{
      id: '701641312858M'
    }, {
      id: '701641312865M'
    }, {
      id: '701641312834M'
    }, {
      id: '701641312841M'
    }, {
      id: '701641312810M'
    }, {
      id: '701641312827M'
    }, {
      id: '701641312872M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Roll Up Cargo Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9f11c8e4/images/large/PG.10224067.JJ169XX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9f11c8e4/images/large/PG.10224067.JJ169XX.PZ.jpg',
      title: 'Roll Up Cargo Pant, '
    },
    orderable: true,
    price: 47.99,
    productId: '25564782M',
    productName: 'Roll Up Cargo Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643422074M'
    },
    representedProducts: [{
      id: '701643422074M'
    }, {
      id: '701643422128M'
    }, {
      id: '701643422111M'
    }, {
      id: '701643422098M'
    }, {
      id: '701643422104M'
    }, {
      id: '701643422081M'
    }, {
      id: '701643422135M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Side Button Pleated Skirt, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw05ea84dc/images/large/PG.10227169.JJ3WCXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw05ea84dc/images/large/PG.10227169.JJ3WCXX.PZ.jpg',
      title: 'Side Button Pleated Skirt, '
    },
    orderable: true,
    price: 95.99,
    productId: '25629003M',
    productName: 'Side Button Pleated Skirt',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643408139M'
    },
    representedProducts: [{
      id: '701643408139M'
    }, {
      id: '701643408177M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Flat Front Pant, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw7e830b49/images/large/PG.10240166.JJ3WCXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw7e830b49/images/large/PG.10240166.JJ3WCXX.PZ.jpg',
      title: 'Flat Front Pant, '
    },
    orderable: true,
    price: 99.0,
    productId: '25589652M',
    productName: 'Flat Front Pant',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643632909M'
    },
    representedProducts: [{
      id: '701643632909M'
    }, {
      id: '701643632930M'
    }, {
      id: '701643632916M'
    }, {
      id: '701643632893M'
    }, {
      id: '701643632886M'
    }, {
      id: '701643632879M'
    }, {
      id: '701643632923M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Pencil Skirt, , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw900cf60d/images/large/PG.10235198.JJ3WCXX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw900cf60d/images/large/PG.10235198.JJ3WCXX.PZ.jpg',
      title: 'Pencil Skirt, '
    },
    orderable: true,
    price: 79.0,
    productId: '25688325M',
    productName: 'Pencil Skirt',
    productType: {
      master: true
    },
    representedProduct: {
      id: '701643317820M'
    },
    representedProducts: [{
      id: '701643317820M'
    }, {
      id: '701643317806M'
    }, {
      id: '701643317813M'
    }, {
      id: '701643317844M'
    }, {
      id: '701643317790M'
    }, {
      id: '701643317837M'
    }, {
      id: '701643317851M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ3WCXX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }, {
    currency: 'USD',
    hitType: 'master',
    image: {
      alt: 'Light Weight Cargo Capri (Master), , large',
      disBaseLink: 'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe7549446/images/large/PG.60114143.JJ169XX.PZ.jpg',
      link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe7549446/images/large/PG.60114143.JJ169XX.PZ.jpg',
      title: 'Light Weight Cargo Capri (Master), '
    },
    orderable: true,
    price: 29.0,
    priceMax: 49.0,
    productId: '25688228M',
    productName: 'Light Weight Cargo Capri (Master)',
    productType: {
      master: true
    },
    representedProduct: {
      id: '609717701479M'
    },
    representedProducts: [{
      id: '609717701479M'
    }, {
      id: '609717701547M'
    }, {
      id: '609717701493M'
    }, {
      id: '609717701554M'
    }, {
      id: '609717701530M'
    }, {
      id: '609717701509M'
    }, {
      id: '609717701486M'
    }],
    variationAttributes: [{
      id: 'color',
      name: 'Color',
      values: [{
        name: 'Black',
        orderable: true,
        value: 'JJ169XX'
      }]
    }, {
      id: 'size',
      name: 'Size',
      values: [{
        name: '4',
        orderable: true,
        value: '004'
      }, {
        name: '6',
        orderable: true,
        value: '006'
      }, {
        name: '8',
        orderable: true,
        value: '008'
      }, {
        name: '10',
        orderable: true,
        value: '010'
      }, {
        name: '12',
        orderable: true,
        value: '012'
      }, {
        name: '14',
        orderable: true,
        value: '014'
      }, {
        name: '16',
        orderable: true,
        value: '016'
      }]
    }]
  }],
  query: '',
  refinements: [{
    attributeId: 'cgid',
    label: 'Category',
    values: [{
      hitCount: 43,
      label: 'New Arrivals',
      value: 'newarrivals'
    }, {
      hitCount: 43,
      label: 'Womens',
      value: 'womens',
      values: [{
        hitCount: 43,
        label: 'Clothing',
        value: 'womens-clothing',
        values: [{
          hitCount: 43,
          label: 'Bottoms',
          value: 'womens-clothing-bottoms'
        }]
      }]
    }]
  }, {
    attributeId: 'c_refinementColor',
    label: 'Color',
    values: [{
      hitCount: 6,
      label: 'Beige',
      presentationId: 'beige',
      value: 'Beige'
    }, {
      hitCount: 43,
      label: 'Black',
      presentationId: 'black',
      value: 'Black'
    }, {
      hitCount: 27,
      label: 'Blue',
      presentationId: 'blue',
      value: 'Blue'
    }, {
      hitCount: 0,
      label: 'Navy',
      presentationId: 'navy',
      value: 'Navy'
    }, {
      hitCount: 15,
      label: 'Brown',
      presentationId: 'brown',
      value: 'Brown'
    }, {
      hitCount: 4,
      label: 'Green',
      presentationId: 'green',
      value: 'Green'
    }, {
      hitCount: 13,
      label: 'Grey',
      presentationId: 'grey',
      value: 'Grey'
    }, {
      hitCount: 0,
      label: 'Orange',
      presentationId: 'orange',
      value: 'Orange'
    }, {
      hitCount: 3,
      label: 'Pink',
      presentationId: 'pink',
      value: 'Pink'
    }, {
      hitCount: 0,
      label: 'Purple',
      presentationId: 'purple',
      value: 'Purple'
    }, {
      hitCount: 1,
      label: 'Red',
      presentationId: 'red',
      value: 'Red'
    }, {
      hitCount: 30,
      label: 'White',
      presentationId: 'white',
      value: 'White'
    }, {
      hitCount: 0,
      label: 'Yellow',
      presentationId: 'yellow',
      value: 'Yellow'
    }, {
      hitCount: 2,
      label: 'Miscellaneous',
      presentationId: 'miscellaneous',
      value: 'Miscellaneous'
    }]
  }, {
    attributeId: 'c_isNew',
    label: 'New Arrival',
    values: [{
      hitCount: 4,
      label: 'true',
      value: 'true'
    }]
  }, {
    attributeId: 'c_bottomType',
    label: 'Type | Use'
  }, {
    attributeId: 'c_size',
    label: 'Size',
    values: [{
      hitCount: 31,
      label: '4',
      value: '4'
    }, {
      hitCount: 32,
      label: '6',
      value: '6'
    }, {
      hitCount: 32,
      label: '8',
      value: '8'
    }, {
      hitCount: 34,
      label: '10',
      value: '10'
    }, {
      hitCount: 31,
      label: '12',
      value: '12'
    }, {
      hitCount: 33,
      label: '14',
      value: '14'
    }, {
      hitCount: 32,
      label: '16',
      value: '16'
    }, {
      hitCount: 5,
      label: 'XS',
      value: 'XS'
    }, {
      hitCount: 8,
      label: 'S',
      value: 'S'
    }, {
      hitCount: 8,
      label: 'M',
      value: 'M'
    }, {
      hitCount: 6,
      label: 'L',
      value: 'L'
    }, {
      hitCount: 7,
      label: 'XL',
      value: 'XL'
    }, {
      hitCount: 0,
      label: '10P',
      value: '10P'
    }, {
      hitCount: 0,
      label: '12P',
      value: '12P'
    }, {
      hitCount: 0,
      label: '14P',
      value: '14P'
    }, {
      hitCount: 0,
      label: '14W',
      value: '14W'
    }, {
      hitCount: 0,
      label: '16W',
      value: '16W'
    }, {
      hitCount: 0,
      label: '18W',
      value: '18W'
    }, {
      hitCount: 0,
      label: '20W',
      value: '20W'
    }, {
      hitCount: 0,
      label: '22W',
      value: '22W'
    }, {
      hitCount: 0,
      label: '24W',
      value: '24W'
    }, {
      hitCount: 0,
      label: '2P',
      value: '2P'
    }, {
      hitCount: 0,
      label: '4P',
      value: '4P'
    }, {
      hitCount: 0,
      label: '6P',
      value: '6P'
    }, {
      hitCount: 0,
      label: '8P',
      value: '8P'
    }]
  }, {
    attributeId: 'c_waist',
    label: 'Waist'
  }, {
    attributeId: 'c_length',
    label: 'Length'
  }, {
    attributeId: 'price',
    label: 'Price',
    values: [{
      hitCount: 5,
      label: '$20 - $49.99',
      value: '(20..50)'
    }, {
      hitCount: 32,
      label: '$50 - $99.99',
      value: '(50..100)'
    }, {
      hitCount: 6,
      label: '$100 - $499.99',
      value: '(100..500)'
    }]
  }],
  searchPhraseSuggestions: {},
  selectedRefinements: {
    cgid: 'womens-clothing-bottoms',
    c_refinementColor: 'Black',
    htype: 'master'
  },
  selectedSortingOption: 'best-matches',
  sortingOptions: [{
    id: 'best-matches',
    label: 'Best Matches'
  }, {
    id: 'price-low-to-high',
    label: 'Price Low To High'
  }, {
    id: 'price-high-to-low',
    label: 'Price High to Low'
  }, {
    id: 'product-name-ascending',
    label: 'Product Name A - Z'
  }, {
    id: 'product-name-descending',
    label: 'Product Name Z - A'
  }, {
    id: 'brand',
    label: 'Brand'
  }, {
    id: 'most-popular',
    label: 'Most Popular'
  }, {
    id: 'top-sellers',
    label: 'Top Sellers'
  }],
  offset: 0,
  total: 43
};